import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class AuthService {
  constructor(private myRoute: Router) { }
  sendToken(token: string) {
    localStorage.setItem('token', token);
  }
  getToken() {
    return localStorage.getItem('token');
  }
  isLoggedIn() {
    return this.getToken() !== null;
  }

  // Migracja logowania na JWT (05.08.2026): kto byl zalogowany PRZED tą zmianą
  // ma w localStorage stary "token" (sam login jako tekst, np. "PatrykIT"),
  // nie JWT. isLoggedIn() by to przepuscil, a kazde wywolanie chronionego
  // endpointu (np. /profil) konczylo sie 401 bez jasnego komunikatu dla usera.
  // Nie weryfikujemy podpisu (to i tak robi backend) - tylko odrzucamy
  // ewidentnie stary/nieprawidlowy ksztalt tokenu.
  hasValidJwtShape(): boolean {
    const token = this.getToken();
    return !!token && token.split('.').length === 3;
  }
  logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('LoggedInUser');
    // PermissionsService trzyma spłaszczoną mapę uprawnień w sessionStorage
    // (patrz core/permissions/permissions.service.ts) - musi zniknąć razem
    // z sesją, inaczej kolejne logowanie na innego usera w tej samej karcie
    // startowałoby z cudzymi uprawnieniami do czasu pierwszego refresh().
    sessionStorage.removeItem('ResolvedPermissions');
    this.myRoute.navigate(['login']);
  }

  getLoggedUser(): any | null {
    const raw = localStorage.getItem('LoggedInUser');

    if (!raw) {
      return null;
    }

    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  getCurrentUserId(): number | null {
    const user = this.getLoggedUser();

    return user?.id ? Number(user.id) : null;
  }
}
